import { render, staticRenderFns } from "./InputMailContents.vue?vue&type=template&id=95edd408"
import script from "./InputMailContents.vue?vue&type=script&lang=ts"
export * from "./InputMailContents.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports